import { render, staticRenderFns } from "./EmptyPlaceholder.vue?vue&type=template&id=d780ab40&scoped=true"
import script from "./EmptyPlaceholder.vue?vue&type=script&lang=js"
export * from "./EmptyPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./EmptyPlaceholder.vue?vue&type=style&index=0&id=d780ab40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d780ab40",
  null
  
)

export default component.exports